export const PROPERTIES_FILTER = {
  filter: {
    status: 1,
  },
};

export const STATUS = ["unscheduled", "scheduled", "active", "completed", "cancelled", "no_show"];

export const STATUS_COLORS = {
  unscheduled: {
    text: "text-amber-800",
    bg: "bg-amber-100",
    bgAccent: "bg-amber-600",
    border: "border-amber-200",
    badge: "bg-amber-200",
  },
  scheduled: {
    text: "text-stone-800",
    bg: "bg-stone-100",
    bgAccent: "bg-stone-600",
    border: "border-stone-200",
    badge: "bg-stone-200",
  },
  active: {
    text: "text-sky-800",
    bg: "bg-sky-100",
    bgAccent: "bg-sky-600",
    border: "border-sky-200",
    badge: "bg-sky-200",
  },
  completed: {
    text: "text-green-800",
    bg: "bg-green-100",
    bgAccent: "bg-green-600",
    border: "border-green-200",
    badge: "bg-green-200",
  },
  cancelled: {
    text: "text-rose-800",
    bg: "bg-rose-100",
    bgAccent: "bg-rose-600",
    border: "border-rose-200",
    badge: "bg-rose-200",
  },
  no_show: {
    text: "text-red-800",
    bg: "bg-red-100",
    bgAccent: "bg-red-600",
    border: "border-red-200",
    badge: "bg-red-200",
  },
} as const;

export const ADJUSTMENT_ACTIONS_TYPES = {
  ADJUST_END_TIME: "adjust_end_time",
  ADJUST_START_TIME: "adjust_start_time",
  ADJUST_BOTH_TIMES: "adjust_both_times",
  ADJUST_PLANNED_TIMES: "adjust_planned_times",
  EMERGENCY_SHIFT_CORRECTION: "emergency_shift_correction",
  MARK_NO_SHOW: "mark_no_show",
} as const;

export const ADJUSTMENT_ACTIONS = [
  {id: ADJUSTMENT_ACTIONS_TYPES.ADJUST_END_TIME, requiredNewStart: false, requiredNewEnd: true},
  {id: ADJUSTMENT_ACTIONS_TYPES.ADJUST_START_TIME, requiredNewStart: true, requiredNewEnd: false},
  {id: ADJUSTMENT_ACTIONS_TYPES.ADJUST_BOTH_TIMES, requiredNewStart: true, requiredNewEnd: true},
  {
    id: ADJUSTMENT_ACTIONS_TYPES.EMERGENCY_SHIFT_CORRECTION,
    requiredNewStart: true,
    requiredNewEnd: true,
  },
  {id: ADJUSTMENT_ACTIONS_TYPES.ADJUST_PLANNED_TIMES, requiredNewStart: true, requiredNewEnd: true},
  {id: ADJUSTMENT_ACTIONS_TYPES.MARK_NO_SHOW, requiredNewStart: false, requiredNewEnd: false},
] as const;

export const ADJUSTMENT_ACTIONS_ENUM = [
  ADJUSTMENT_ACTIONS_TYPES.ADJUST_END_TIME,
  ADJUSTMENT_ACTIONS_TYPES.ADJUST_START_TIME,
  ADJUSTMENT_ACTIONS_TYPES.ADJUST_BOTH_TIMES,
  ADJUSTMENT_ACTIONS_TYPES.ADJUST_PLANNED_TIMES,
  ADJUSTMENT_ACTIONS_TYPES.EMERGENCY_SHIFT_CORRECTION,
  ADJUSTMENT_ACTIONS_TYPES.MARK_NO_SHOW,
] as const;

export const BREAK_RULES: [number, {rest: number; lunch: number}][] = [
  [14.01, {rest: 4, lunch: 2}],
  [10.01, {rest: 3, lunch: 2}],
  [6.01, {rest: 2, lunch: 1}],
  [5.01, {rest: 1, lunch: 1}],
  [3.51, {rest: 1, lunch: 0}],
];

export const BREAK_RULE_DEFAULT = {rest: 0, lunch: 0};
